import { Link } from "react-router-dom";
import { Mail, Phone, ShieldCheck, Sparkles, Truck, Droplets } from "lucide-react";
import Logo from "../Logo";

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-[#EAE8E4] mt-28 border-t border-[#262626]" data-testid="footer">
      <div className="container-queen py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand Col */}
          <div className="md:col-span-1 space-y-5">
            <div className="inline-block bg-white p-2.5 rounded-xl shadow-md">
              <Logo height={28} />
            </div>
            <p className="text-sm text-[#999999] leading-relaxed font-body">
              The Queen incarne l'excellence de la haute dermatologie. Des sérums hautement concentrés, purs et testés cliniquement pour révéler l'éclat intemporel de votre peau.
            </p>
            <div className="pt-2 text-xs text-[#888888] space-y-1">
              <p className="flex items-center gap-2"><ShieldCheck size={14} className="text-[#C5A880]" /> Formulé sous contrôle dermatologique</p>
              <p className="flex items-center gap-2"><Droplets size={14} className="text-[#0284C7]" /> Actifs purs &amp; haute concentration</p>
            </div>
          </div>

          {/* Collection Links */}
          <div>
            <h4 className="label-eyebrow text-[#C5A880] mb-5 tracking-[0.2em]">Les Sérums</h4>
            <ul className="space-y-3 text-sm text-[#CCCCCC] font-body">
              <li>
                <Link to="/product/serum-vitamine-c" className="hover:text-white transition-colors flex items-center justify-between">
                  <span>Sérum Vitamine C Pure</span>
                  <span className="text-[11px] text-[#D97706]">15% C+E</span>
                </Link>
              </li>
              <li>
                <Link to="/product/serum-acide-hyaluronique" className="hover:text-white transition-colors flex items-center justify-between">
                  <span>Sérum Acide Hyaluronique</span>
                  <span className="text-[11px] text-[#0284C7]">Multi-Moléculaire</span>
                </Link>
              </li>
              <li>
                <Link to="/product/le-duo-royal-coffret-serums" className="hover:text-white transition-colors flex items-center justify-between">
                  <span>Le Duo Royal (Coffret Synergie)</span>
                  <span className="text-[11px] text-[#C5A880]">Protocole 24h</span>
                </Link>
              </li>
              <li>
                <Link to="/shop" className="hover:text-white transition-colors">
                  Tous les Rituels
                </Link>
              </li>
            </ul>
          </div>

          {/* Protocols & Service */}
          <div>
            <h4 className="label-eyebrow text-[#C5A880] mb-5 tracking-[0.2em]">Rituels &amp; Conseil</h4>
            <ul className="space-y-3 text-sm text-[#CCCCCC] font-body">
              <li><Link to="/#routine" className="hover:text-white transition-colors">Protocole Matin &amp; Soir</Link></li>
              <li><Link to="/#ingredients" className="hover:text-white transition-colors">Charte des Ingrédients</Link></li>
              <li><Link to="/#results" className="hover:text-white transition-colors">Études &amp; Avant / Après</Link></li>
              <li><Link to="/apropos" className="hover:text-white transition-colors">La Maison The Queen</Link></li>
              <li><Link to="/orders" className="hover:text-white transition-colors">Suivi de commande</Link></li>
            </ul>
          </div>

          {/* Contact & Algeria Logistics */}
          <div>
            <h4 className="label-eyebrow text-[#C5A880] mb-5 tracking-[0.2em]">Service Client</h4>
            <ul className="space-y-3 text-sm text-[#CCCCCC] font-body">
              <li className="flex items-center gap-2"><Mail size={15} className="text-[#C5A880]" /> contact@thequeen-skincare.com</li>
              <li className="flex items-center gap-2"><Phone size={15} className="text-[#C5A880]" /> +213 (0) 550 00 00 00</li>
              <li className="pt-2">
                <div className="bg-[#1A1A1A] border border-[#2D2D2D] rounded-xl p-3 text-xs text-[#AAAAAA] space-y-1">
                  <p className="text-white font-medium flex items-center gap-1.5"><Truck size={14} className="text-[#C5A880]" /> Expédition 58 Wilayas</p>
                  <p>À domicile ou bureau Stop-Desk.</p>
                  <p className="text-[#888888]">Paiement comptant à la livraison.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Credits */}
        <div className="border-t border-[#222222] mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-[#777777] font-body text-center sm:text-left">
            <p>© {new Date().getFullYear()} The Queen — Haute Dermatologie. Tous droits réservés.</p>
          </div>
          <div className="flex items-center gap-6 text-xs text-[#888888] font-body">
            <span>Paiement à la livraison</span>
            <span className="text-[#C5A880]">✦</span>
            <span>Testé sous contrôle dermatologique</span>
            <span className="text-[#C5A880]">✦</span>
            <span>Non testé sur les animaux</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
